import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import PublicLayout from './components/PublicLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Passageiros from './pages/Passageiros';
import Viagens from './pages/Viagens';
import Assentos from './pages/Assentos';
import Pagamentos from './pages/Pagamentos';
import ListaPassageiros from './pages/ListaPassageiros';
import ResetSenhas from './pages/ResetSenhas';
import Cadastro from './pages/Cadastro';
import Reservar from './pages/Reservar';
import Agradecimento from './pages/Agradecimento';
import Layout from './components/Layout';
// Páginas públicas
import Home from './pages/public/Home';
import ListaViagens from './pages/public/ListaViagens';
import ViagemDetalhes from './pages/public/ViagemDetalhes';
import QuemSomos from './pages/public/QuemSomos';
import GaleriaVideos from './pages/public/GaleriaVideos';
import GaleriaFotos from './pages/public/GaleriaFotos';
import AlbumViagem from './pages/public/AlbumViagem';
import MapaDestinos from './pages/public/MapaDestinos';
// Páginas administrativas
import PreReservas from './pages/admin/PreReservas';
import ContratosOnibus from './pages/admin/ContratosOnibus';
import ConfigContrato from './pages/admin/ConfigContrato';
import DadosEmpresa from './pages/admin/DadosEmpresa';
import GerenciarQuemSomos from './pages/admin/GerenciarQuemSomos';
import GerenciarGaleriaVideos from './pages/admin/GerenciarGaleriaVideos';
import GerenciarGaleriaFotos from './pages/admin/GerenciarGaleriaFotos';
import GerenciarUsuarios from './pages/admin/GerenciarUsuarios';
import Pousadas from './pages/admin/Pousadas';
import ContratosHospedagem from './pages/admin/ContratosHospedagem';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Routes>
          {/* Rotas de Autenticação - DEVEM VIR PRIMEIRO */}
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Cadastro />} />
          <Route path="/reset-senhas" element={<ResetSenhas />} />
          <Route path="/agradecimento" element={<Agradecimento />} />
          
          {/* Rotas Administrativas - DEVEM VIR ANTES DAS PÚBLICAS */}
          <Route
            path="/admin/*"
            element={
              <PrivateRoute>
                <Layout>
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/passageiros" element={<Passageiros />} />
                    <Route path="/viagens" element={<Viagens />} />
                    <Route path="/assentos/:viagemId" element={<Assentos />} />
                    <Route path="/pagamentos" element={<Pagamentos />} />
                    <Route path="/pre-reservas" element={<PreReservas />} />
                    <Route path="/lista-passageiros" element={<ListaPassageiros />} />
                    <Route path="/contratos-onibus" element={<ContratosOnibus />} />
                    <Route path="/hospedagens/pousadas" element={<Pousadas />} />
                    <Route path="/hospedagens/contratos" element={<ContratosHospedagem />} />
                    <Route path="/config-contrato" element={<ConfigContrato />} />
                    <Route path="/dados-empresa" element={<DadosEmpresa />} />
                    <Route path="/site/quem-somos" element={<GerenciarQuemSomos />} />
                    <Route path="/site/galeria-videos" element={<GerenciarGaleriaVideos />} />
                    <Route path="/site/galeria-fotos" element={<GerenciarGaleriaFotos />} />
                    <Route path="/usuarios" element={<GerenciarUsuarios />} />
                    <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                  </Routes>
                </Layout>
              </PrivateRoute>
            }
          />
          
          {/* Rotas Públicas - DEVEM VIR POR ÚLTIMO */}
          <Route
            path="/*"
            element={
              <PublicLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/viagens" element={<ListaViagens />} />
                  <Route path="/mapa" element={<MapaDestinos />} />
                  <Route path="/viagem/:id" element={<ViagemDetalhes />} />
                  <Route path="/reservar/:id" element={<Reservar />} />
                  <Route path="/quem-somos" element={<QuemSomos />} />
                  <Route path="/galeria-videos" element={<GaleriaVideos />} />
                  <Route path="/galeria-fotos" element={<GaleriaFotos />} />
                  <Route path="/galeria-fotos/viagem/:viagem_id" element={<AlbumViagem />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </PublicLayout>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
